const SEQ_PARAM_TEXT = 'SEQ';
const SEQ_PARAM = '<' + SEQ_PARAM_TEXT + '>';
export const hasSourceSeqParam = (str: string) => str && str.indexOf(SEQ_PARAM) >= 0;

const destSeqRegexp = /<([L]+|[R]+|SEQ)>/;
export const hasDestinationSeqParam = (str: string) => destSeqRegexp.test(str);
